import _ from 'lodash';
import { db } from '../../firebase';
import React, { Component } from 'react';
import moment from 'moment-timezone'
import request from 'request';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPencilAlt, faArrowAltCircleRight, faEnvelope, faFileCsv } from "@fortawesome/free-solid-svg-icons";
import stringWidth from "string-width"
import { CSVLink } from "react-csv";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

import { addCheck, allCheck, deleteRecord } from '../../utils/common'

import Header from '../../components/header';
import Footer from '../../components/footer';
import Filter from '../../components/filter';

import lots from "../../data/lot.json";
import menus from "../../data/menu.json";
import apartments from "../../data/apartment.json";
import csv_headers from "../../data/csv_header.json";
const cast_ranks = [{"key": "0", "label": "新人に近い"}, {"key": "1", "label": "何でも受けられる"}]
const google_API_key = "AIzaSyDurXmFvKHHC50mZIV91gU-_kvbRe-LyLc"

const attribute_mst = {"0": "未確定（これからマッチング）", "1": "マッチング中（キャスト未決定）", "2": "マッチング中（キャスト決定）", "3": "確定", "4": "決済済み", "5": "キャンセル（返金前）", "6": "キャンセル（返金済み）"}
//const schedule_mst = {monday: "月", tuesday: "火", wednesday: "水", thursday: "木", friday: "金", saturday: "土", sunday: "日"}
//const weekday_mst = {1:"monday", 2:"tuesday", 3:"wednesday", 4:"thursday", 5:"friday", 6:"saturday", 7:"sunday"}

const containerStyle = {
  width: "100%",
  height: "100%",
};

const center = {lat: 35.668519, lng:139.708725};

export default class Reservations extends Component {
  constructor (props) {
    super(props);

    this.state = {
      users: {},
      csv: [],
      casts: {},
      reservations: [{
        cast_id: "U9ce104f86bea7113e16904603cdeae28",
        createdAt: 1614530220537,
        date: 1614565800000,
        id: "-MUdV-oXNrzPbf_e_tl0",
        lot: "30",
        menu: "1",
        price: "2750",
        user_id: "-MUcjYTUUWMTJBremD4E"
      }],
      schedules: {},
      submenu: "lists",
      contentmenu: "reservation",
      date: "2020/9/16",
      time: "9:00",
      lot: "30",
      menu: "1",
      reservation: {},
      reservation_id: "",
      sends: [],
      checks: {},
      all_check: "false",
      center: [{lat: 35.654948,lng: 139.697679,}, {lat: 35.663808,lng: 139.718068,}, {lat: 35.668519, lng:139.708725}],
      filter: ""
    };
  }

  componentWillMount () {
    var scope = this

    db.ref('reservations').orderByChild("delete").equalTo(null).on('value', snapshot => {
      const reservations_tmp = snapshot.val()
      //console.log(reservations)

      db.ref('pre_reservations').orderByChild("delete").equalTo(null).on('value', snapshot => {
        const pre_reservations_tmp = snapshot.val()

        var reservations = []
        var reservations_arr = {}

        for( let n in reservations_tmp ) {
          for( let m in reservations_tmp[n] ) {
            reservations_arr = reservations_tmp[n][m]
            reservations_arr["id"] = m
            reservations_arr["user_id"] = n
            reservations_arr["attribute"] = "1"
            if (!reservations_arr["rank"]) {
              reservations_arr["rank"] = "0"
            }
            reservations_arr["ref"] = "reservations/" + n
            if (menus.find(menu => menu.id === reservations_tmp[n][m]["menu"])) {
              reservations_arr["menu"] = menus.find(menu => menu.id === reservations_tmp[n][m]["menu"]).title
            }
            reservations.push(reservations_arr)
          }
        }
        for( let n in pre_reservations_tmp ) {
          for( let m in pre_reservations_tmp[n] ) {
            reservations_arr = pre_reservations_tmp[n][m]
            reservations_arr["id"] = m
            reservations_arr["user_id"] = n
            reservations_arr["attribute"] = pre_reservations_tmp[n][m]["attribute"] || "0"
            if (!reservations_arr["rank"]) {
              reservations_arr["rank"] = "0"
            }
            reservations_arr["ref"] = "pre_reservations/" + n
            reservations.push(reservations_arr)
          }
        }
        console.log(reservations)
        
        scope.setState({ reservations: reservations })

        db.ref('users').on('value', snapshot => {
          var users = snapshot.val()


          // LP登録ユーザーの情報を見つけてusersに追加
          db.ref('lp/users').orderByChild("delete").equalTo(null).on('value', snapshot => {
            var lp_users = snapshot.val()
            for(let i in lp_users) {
              lp_users[i]["id"] = i
              lp_users[i]["ref"] = "lp/users/" + i
              if (!lp_users[i].attribute) {
                lp_users[i]["attribute"] = "0"
              }
              if (lp_users[i].menu_etc) {
                if ("" !== lp_users[i]["menu"]) {
                  lp_users[i]["menu"] += "、"
                }
                lp_users[i]["menu"] += "その他（" + lp_users[i].menu_etc + "）"
              }
              users[i] = lp_users[i];
            }
            scope.setState({ users: users })
          });
        });
      });
    });


    db.ref('casts').orderByChild("delete").equalTo(null).on('value', snapshot => {
      var casts = snapshot.val()
      for (let i in casts) {
        casts[i]["id"] = i
      }
      scope.setState({ casts: casts })
    });

    db.ref('schedules').orderByChild("delete").equalTo(null).on('value', snapshot => {
      var schedules = snapshot.val()
      scope.setState({ schedules: schedules })
    });
    


    //this.getReservation(this.state.user_id)

  }

  getReservation (id) {
    db.ref('reservations/' + id).on('value', snapshot => {
      //const reservations = _.values(snapshot.val())
      //console.log(reservations)
      //this.setState({ reservations })
    });
  }
  
  changeSubMenu (menu_name) {
    this.setState({submenu: menu_name})
  }

  changeUser(reservation, id) {
    var user_address = this.state.users[reservation.user_id].address
    console.log(user_address)
    var options3 = {
      uri: "https://maps.googleapis.com/maps/api/distancematrix/json?origins=東京都渋谷区神宮前4-22-7&destinations=" + user_address + "&mode=walking&language=ja&key=" + google_API_key,
      headers: {}
    }

    request.get(options3, function(error, response, body){
      console.log(response, body)
    });

    this.setState({ reservation: reservation, reservation_id: id })
    this.getReservation(id)
  }

  alt (e) {
    if (e) {
      var v = {}
      if ("DIV" === e.target.tagName) {
        v = {alt: true, alt_text: e.target.innerHTML, alt_x: e.currentTarget.getBoundingClientRect().left + 20, alt_y: e.currentTarget.getBoundingClientRect().top - 25}
        if (e.currentTarget.offsetWidth <= stringWidth(e.target.innerHTML) * 7.7) {
          this.handle = setTimeout(() => {
            this.setState(v)
          }, 300)
        }
      } else {
        v = {alt: true, alt_text: e.currentTarget.dataset.alt, alt_x: e.currentTarget.getBoundingClientRect().left + 10, alt_y: e.currentTarget.getBoundingClientRect().top - 25}
        this.handle = setTimeout(() => {
          this.setState(v)
        }, 300)
      }
    } else {
      clearTimeout(this.handle);
      this.setState({alt: false})
    }
  }

  setReservationInfo(obj) {
    var reservation = this.state.reservation
    let k = Object.keys(obj)
    let v = Object.values(obj)
    if ("date" === k[0]) {
      v[0] = moment(v[0] + " " + ('00' + moment(reservation.date).hour()).slice(-2) + ":" + ('00' + moment(reservation.date).minute()).slice(-2), "YYYY/MM/DD HH:mm").unix() * 1000
    }
    if ("time" === k[0]) {
      k[0] = "date"
      v[0] = moment(moment(reservation.date).format("YYYY/MM/DD") + " " + v[0], "YYYY/MM/DD HH:mm").unix() * 1000
    }
    reservation[k[0]] = v[0]
    reservation["editing"] = 1
    console.log(reservation)
    this.setState({reservation: reservation})
  }

  editConfirm(id) {
    var data = _.cloneDeep(this.state.reservation);
    data.adminUpdatedAt = Date.now();

    var reservation_info = {
      menu: data.menu,
      lot: data.lot,
      createdAt: data.createdAt,
      adminUpdatedAt: data.adminUpdatedAt
    }

    if (data.menu_etc) {
      reservation_info.menu_etc = data.menu_etc
    }
    if (data.date) {
      reservation_info.date = data.date
    }
    if (data.attribute) {
      reservation_info.attribute = data.attribute
    }
    if (data.rank) {
      reservation_info.rank = data.rank
    }
    if (data.price) {
      reservation_info.price = data.price
    }
    if (data.user_id) {
      reservation_info.user_id = data.user_id
    }
    if (data.cast_id) {
      reservation_info.cast_id = data.cast_id
    }
    if (data.dates) {
      reservation_info.dates = data.dates
    }
    if (data.casts) {
      reservation_info.casts = data.casts
    }

    console.log(reservation_info)

    db.ref(data.ref + "/" + id).update(reservation_info).then(function() {// Update successful.
      //window.location.href = process.env.REACT_APP_PUBLIC_URL + "/admin_pre_users";
      window.location.href = "admin_reservations";
    }).catch(function (error) {
      // An error happened.
    });
  }

  // Datesに該当するスケジュールを持つキャストを配列で返す（その際に該当する日付も配列に加える）
  listOfCastWhoFitDatesAndRank(dates, lot, rank, casts, schedules) {
    var list = _.values(casts).filter(cast => {
      let ret
      if (!cast.rank) {
        cast.rank = "0"
      }
      cast.dates = []
      if (parseInt(rank, 10) <= parseInt(cast.rank, 10)) {
        for (let n in schedules[cast.id]) {
          for (let m in dates) {
            if (schedules[cast.id][n].repeat === false) {
              if (schedules[cast.id][n].start <= parseInt(dates[m], 10) && schedules[cast.id][n].end >= parseInt(dates[m], 10)) {
                cast.dates.push(dates[m])
              }
            } else {
              // 繰り返しの場合、1週間ごとのサイクル内で、時間内か
              let date = moment(parseInt(dates[m], 10))
              let start = moment(schedules[cast.id][n].start)
              let date_time = moment("2021-01-01 " + date.format("HH:mm"))  // 時間だけ抜き出し
              let start_time = "2021-01-01 " + moment(schedules[cast.id][n].start).format("HH:mm")
              let end_time ="2021-01-01 " +  moment(schedules[cast.id][n].end).format("HH:mm")
              let date_end_time = moment("2021-01-01 " + moment(parseInt(dates[m], 10)).add(parseInt(lot, 10), "minutes").format("HH:mm"))
              if (date.diff(start, 'days') % 7 === 0 && date_time.isSameOrAfter(start_time) && date_end_time.isSameOrBefore(end_time)) {
                cast.dates.push(dates[m])
              }
            }
          }
          if (cast.dates.length !== 0) {
            ret = cast
          }
        }
      }
      return ret
    })
    return list
  }

  reservationSend (reservation, casts, schedules) {

    var list = this.listOfCastWhoFitDatesAndRank(reservation.dates, reservation.lot, reservation.rank, casts, schedules)
    //console.log(list)

    var sendgrid_url = process.env.REACT_APP_FUNCTIONS_URL + "/email"
    var title = "あなたに依頼が届きました／三菱地所の家事代行30min."
    var menu_text = reservation.menu
    if (reservation.menu_etc) {
      if ("" !== menu_text) {
        menu_text += "、"
      }
      menu_text += "その他（" + reservation.menu_etc + "）"
    }
    var menu_info_text = ""

    Promise.all(list.map((cast, i) => {
      return new Promise((resolve, reject) => {
        menu_info_text = "掃除内容：" + menu_text + "\n時間数：" + reservation.lot + "分\n"
        var date_text = ""
        for (let n in cast.dates) {
          date_text += "日時(第" + (parseInt(n, 10) + 1) + "希望)：" + moment(parseInt(cast.dates[n], 10)).format("YYYY/MM/DD(dddd)HH:mm") + "〜\n"
        }
        menu_info_text += date_text

        // メールのリンクは cast_agreement/キャストID/ユーザーID/pre予約ID
        var agreement_url = process.env.REACT_APP_PUBLIC_URL + "/cast_agreement/" + cast.id + "/" + reservation.user_id + "/" + reservation.id
        var text = "こんにちは、三菱地所の家事代行 30min.事務局でございます。\nあなた宛に掃除の依頼が届きました。\n\n■依頼内容\n" + menu_info_text + "\n承諾いただける場合は下記のリンクにアクセスしてください。\n" + agreement_url + "\n*承諾が早かったキャストにご依頼が行きます。\n他のキャストが先に承諾した場合はあなたへの依頼は取り下げられますのでご了承ください。\nよろしくお願いいたします。\n----------------------------------------\n三菱地所の家事代行30min. 事務局\nthirty-min@mec.co.jp"
        var options4 = {
          uri: sendgrid_url,
          headers: {
            "Content-type": "application/json",
          },
          json: {
            "ids": cast.id,
            "emails": cast.email,
            "subject": title,
            "body": text
          }
        }
        // メール送付(async)
        request.post(options4, function(error, response, body) {
          if (error) {
            // An error happened.
            reject("error")
          } else {
            resolve("success")
          }
        });
      });
    })).then(result => {
      db.ref(reservation.ref + "/" + reservation.id).update({rank: reservation.rank}).then(function() {
        window.location.href = "/admin_reservations"
      })
    }).catch(err => {
      console.log(err)
    });
  }

  render () {

    var scope = this

    const reservation_list = this.state.reservations.map(reservation => {
      var ret
      if (this.state.users[reservation.user_id]) {
        var user = this.state.users[reservation.user_id]
        let name = user.lastName
        if (user.family_name) {
          name = user.family_name + " " + user.first_name
        }
        ret = <li className={[reservation.id === this.state.reservation_id ? "user active" : "user"]} onClick={e => this.changeUser(reservation, reservation.id, "")}>
          <img src={user.picture} alt="" className="profile" height="30" />
          <div>
            <p className="message_date">{moment(reservation.createdAt).format('YYYY/MM/DD')}</p>
            <p className="user_name">{name}</p>
            <p className="message_summary">...</p>
          </div>
        </li>
        ;
      }
      return ret
    });

    const reservation_detail_list = this.state.reservations.map(reservation => {
      var ret
      if (this.state.users[reservation.user_id]) {
      ret = <li key={reservation.id} onClick={e => this.changeUser(reservation, reservation.id)} onDoubleClick={e => this.changeSubMenu("operation")}>
        <div><img alt="□" src={"/images/check_" + this.state.checks[reservation.id] + ".png"} onClick={e => addCheck(reservation.id, "", "", this.state.reservations, this.state.sends, this.state.checks, this.state.all_check, (callback) => {this.setState(callback)})} className="checkbox_image" /></div>
        <div className="long"><span className={[reservation.attribute === "0" ? "cp" : ""]}>{attribute_mst[reservation.attribute]}</span></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="long alt_source">{moment(reservation.date).format('MM/DD(dddd) HH:mm')}〜{moment(reservation.date).add(reservation.lot, "m").format('HH:mm')}（{reservation.lot}分）</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{this.state.users[reservation.user_id].family_name + " " + this.state.users[reservation.user_id].first_name}</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{this.state.users[reservation.user_id].address}</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{this.state.users[reservation.user_id].apartment}</div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source"></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{this.state.users[reservation.user_id].tel}</div>
        <div><a href={"mailto:" + this.state.users[reservation.user_id].email}>{this.state.users[reservation.user_id].email}</a></div>
        <div></div>
        <div>{moment(reservation.createdAt).format('MM/DD(dddd) HH:mm')}</div>
        <div></div>
        <div onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()} className="alt_source">{reservation.memo}</div>
        <div>
          <p data-alt="編集" onClick={e => this.editUser()} onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()}><FontAwesomeIcon icon={faPencilAlt} /></p>
          <p data-alt="削除" onClick={e => deleteRecord("", reservation.ref, "/admin_reservations")} onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()}><FontAwesomeIcon icon={faTrash} /></p>
          <p data-alt="オペレーション" onClick={e => this.changeSubMenu("operation")} onMouseOver={e => this.alt(e)} onMouseOut={e => this.alt()}><FontAwesomeIcon icon={faArrowAltCircleRight} /></p>
        </div>
      </li>
      ;
      }
      return ret
    });

    const vip = () => {
      let ret
      if (this.state.reservation) {
        if (this.state.reservation.user_id) {
          ret = apartments.map(vip => {
            let ret
            let regex = new RegExp(vip + '(.*?)', 'g')
            if (regex.test(scope.state.users[scope.state.reservation.user_id].apartment)) {
              ret = <p>{vip}に該当しています</p>
            }
            return ret
          })
        }
      }
      return ret
    }

    const reservation_date_list = () => {
      let ret
      if (this.state.reservation_id) {
        if (this.state.reservation.dates) {
          let cnt = 0
          const dates = this.state.reservation.dates.map(date => {
            cnt++
            return <p>第{cnt}希望：{moment(parseInt(date, 10)).format('MM/DD(dddd) HH:mm')}</p>
          });
          ret = dates
        }
      }
      return ret
    }

    const reservation_cast_list = () => {
      let ret
      if (this.state.reservation_id) {
        if (this.state.reservation.casts) {
          const dates = this.state.reservation.dates.map((date, i) => {
            let casts = this.listOfCastWhoFitDatesAndRank([date], this.state.reservation.lot, this.state.reservation.rank, this.state.casts, this.state.schedules).map(cast => {
              let rank = ""
              if (cast_ranks.find(rank => rank.key === cast.rank)) {
                rank = cast_ranks.find(rank => rank.key === cast.rank).label
              }
              return <li>{cast.name}（{rank}）</li>
            })
            if (casts.length === 0) {
              casts = <li>該当なし</li>
            }
            return <div><p>第{i + 1}希望</p><ul>{casts}</ul></div>
          });
          ret = <div>{dates}</div>
        }
      }
      return ret
    }

    const dates = [];
    moment.locale('ja', {weekdays: ["日", "月", "火", "水", "木", "金", "土"]});
    for (let i = 0; i <= 30; i++) {
      dates.push(
        <option value={moment().add('days', i).format('YYYY/MM/DD')}>{moment().add('days', i).format('YYYY年MM月DD日(dddd)')}</option>
      )
    }

    const pins = this.state.center.map(pin => {
      return <Marker position={pin} />
    })

    const reservation_agreement = () => {
      let ret
      if (this.state.reservation.agree_cast) {
        ret = <>
          <p>日程：第{this.state.reservation.agreement}希望日程</p>
          <p>キャスト：{this.state.casts[this.state.reservation.agree_cast].name}</p>
        </>
      }
      return ret
    }

    const lot_list = lots.map(lot => {
      let selected = ""
      if (this.state.reservation.lot === lot.value) {
        selected = "selected"
      }
      return <option key={lot.value} value={lot.value} selected={selected}>{lot.label}</option>;
    });

    const reservation_edit = () => {
      let ret
      if (this.state.reservation_id) {
        var dates = [];
        moment.updateLocale('ja', {weekdays: ["日", "月", "火", "水", "木", "金", "土"]});
        var serviceStartDate = "2021-03-01 00:00:00"
        let start = moment(serviceStartDate)
        for (let i = 0; i <= moment().diff(start, 'days') + 30; i++) {
          let selected = ""
          if (moment(this.state.reservation.date).isSame(moment(serviceStartDate).add(i, 'days'), 'day')) {
            selected = "seleced"
          }
          dates.push(
            <option key={i} value={moment(serviceStartDate).add(i, 'days').format('YYYY/MM/DD')} selected={selected}>{moment(serviceStartDate).add(i, 'days').format('YYYY年MM月DD日(dddd)')}</option>
          )
        }

        var times = []
        for (let i = 0; i <= 17; i++) {
          let time = moment("2021-01-01 09:00").add(i * 30, "minute")
          let selected = ""
          if (('00' + moment(this.state.reservation.date).hour()).slice(-2) + ":" + ('00' + moment(this.state.reservation.date).minute()).slice(-2) === time.format("HH:mm")) {
            selected = "selected"
          }
          times.push(
            <option value={time.format("HH:mm")} selected={selected}>{time.format("HH:mm")}〜</option>
          )
        }

        var cast_list = _.values(this.state.casts).map(cast => {
          let name = cast.name
          if (name === void 0) {
            name = cast.lastName + " *氏名未登録"
          }
          let selected = ""
          if (this.state.reservation.cast_id && this.state.reservation.cast_id === cast.id) {
            selected = "selected"
          }
          return <option key={cast.id} value={cast.id} selected={selected}>{name}</option>
        })

        ret = <div className="information-contents-wrapper">
          <dl>
            <dt>ステータス</dt><dd><select name="attribute" value={this.state.reservation.attribute} onChange={e => this.setReservationInfo({attribute: e.target.value})}>
              <option value="0">仮予約</option>
              <option value="1">確定</option>
            </select></dd>
            <dt>メニュー</dt><dd><textarea value={this.state.reservation.menu} onChange={e => this.setReservationInfo({menu: e.target.value})} /></dd>
            <dt>メニュー（その他）</dt><dd><textarea value={this.state.reservation.menu_etc} onChange={e => this.setReservationInfo({menu_etc: e.target.value})} /></dd>
            <dt>時間数</dt><dd><select onChange={e => this.setReservationInfo({lot: e.target.value})}>
              {lot_list}
            </select></dd>
            <dt>物件ランク</dt><dd><select name="rank" value={this.state.reservation.rank} onChange={e => this.setReservationInfo({rank: e.target.value})}>
              <option value="0">普通</option>
              <option value="1">要注意</option>
            </select></dd>
            <dt>確定日程</dt><dd><select onChange={e => this.setReservationInfo({date: e.target.value})}>
              <option value="">未定</option>
              {dates}
            </select>
            <select onChange={e => this.setReservationInfo({time: e.target.value})}>
              <option value="">未定</option>
              {times}
            </select></dd>
            <dt>確定キャスト</dt><dd><select onChange={e => this.setReservationInfo({cast_id: e.target.value})}>
              <option value="">未定</option>
              {cast_list}
            </select></dd>
          </dl>
        </div>
      }
      return ret
    }

    return <div className="admin">
    <Header />
      <div className="admin-sub-menus">
        <ul>
          <li className={ this.state.submenu === "lists" ? "active" : "" } onClick={e => this.changeSubMenu("lists")}>案件一覧</li>
          <li className={ this.state.submenu === "operation" ? "active" : "" } onClick={e => this.changeSubMenu("operation")}>オペレーション</li>
          <li className={ this.state.submenu === "map" ? "active" : "" } onClick={e => this.changeSubMenu("map")}>地図表示</li>
        </ul>
      </div>
      <div className="admin-contents-wrapper">
        <div className={ this.state.submenu === "lists" ? "admin-user-lists active" : "admin-user-lists" }>

          <div className={ this.state.alt === true ? "alt show" : "alt hide" } style={{ top: this.state.alt_y, left: this.state.alt_x }}>{this.state.alt_text}</div>
          <ul className="user-list-menu">
            <li><img alt="□" src={"/images/check_" + this.state.all_check + ".png"} onClick={e => allCheck(this.state.all_check, this.state.reservations, (callback) => {this.setState(callback)})} className="checkbox_image" /></li>
            <li onClick={e => this.changeSubMenu("operations")}><span><FontAwesomeIcon icon={faEnvelope} />送信</span></li>
            <li><span><FontAwesomeIcon icon={faTrash} />削除</span></li>
            <li><span><FontAwesomeIcon icon={faFileCsv} /><CSVLink data={this.state.csv} headers={csv_headers}>ダウンロード</CSVLink></span></li>
            <li><Filter state={this.state} onChange={e => this.changeStateFromChild(e)} /></li>
          </ul>
          <ul className="user-list">
            <li className="user-list-title">
              <div></div>
              <div className="long">属性</div>
              <div className="long">サービス提供日</div>
              <div>氏名</div>
              <div>住所</div>
              <div>マンション</div>
              <div>最寄駅</div>
              <div>電話番号</div>
              <div>メールアドレス</div>
              <div></div>
              <div>登録日</div>
              <div>担当</div>
              <div>メモ</div>
              <div>管理</div>
            </li>
            {reservation_detail_list}
          </ul>
        </div>

        <div className={ this.state.submenu === "operation" ? "admin-user-operation active" : "admin-user-operation" }>
          <ul className="side-menu">
            <Filter state={this.state} onChange={e => this.changeStateFromChild(e)} />
            <div className="side-list">
              {reservation_list}
            </div>
          </ul>
          <div className="right-informations">
          </div>
          <div className="admin-contents messages">
            <div className="user-operation-menu">
              <ul>
                <li className={ this.state.contentmenu === "reservation" ? "active" : ""} onClick={e => this.setState({contentmenu: "reservation"})}>予約</li>
                <li className={ this.state.contentmenu === "asign" ? "active" : ""} onClick={e => this.setState({contentmenu: "asign"})}>アサイン</li>
                <li className={ this.state.contentmenu === "edit" ? "active" : ""} onClick={e => this.setState({contentmenu: "edit"})}>情報編集</li>
              </ul>
              <br className="clear" />
            </div>
            <ul className={ this.state.contentmenu === "reservation" ? "reservation-history active" : "reservation-history"}>
              <div className="reservation-contents-wrapper">
              <dl>
                <dt>ステータス</dt><dd>{attribute_mst[this.state.reservation.attribute]}{reservation_agreement()}</dd>
                <dt>案件ランク</dt><dd>
                  <select name="rank" value={this.state.reservation.rank} onChange={e => this.setReservationInfo({rank: e.target.value})}>
                    <option value="0">普通</option>
                    <option value="1">要注意</option>
                  </select>
                  <div>{vip()}</div>
                </dd>
                <dt>希望日程一覧</dt><dd>
                  {reservation_date_list()}
                </dd>
                <dt>対応可能キャスト一覧</dt><dd>
                  {reservation_cast_list()}
                </dd>
              </dl>
              </div>
            </ul>
            <ul className={ this.state.contentmenu === "edit" ? "user-edit active" : "user-edit"}>
              {reservation_edit()}
            </ul>
          </div>
          <div className={ this.state.contentmenu === "reservation" ? "reservation" : "reservation hide"} >
            <div className="reservation-conditions">
            案件ランクの確定を行うとランクに応じたキャスト全員へ一斉に連絡が送られます。
              <button onClick={e => this.reservationSend(this.state.reservation, this.state.casts, this.state.schedules)} value>確定</button>
            </div>
          </div>
          <div className={ this.state.contentmenu === "edit" ? "user-edit" : "user-edit hide"} >
            <div className="reservation-conditions">
              <p>{this.state.reservation.editing === 1 ? "データ編集中(未確定)" : ""}</p>
              <button onClick={e => this.editConfirm(this.state.reservation_id)} value>更新</button>
            </div>
          </div>
        </div>

        <div className={ this.state.submenu === "map" ? "admin-user-operation active" : "admin-user-operation" }>
          <LoadScript googleMapsApiKey={google_API_key}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={14}
            >
              {pins}
            </GoogleMap>
          </LoadScript>
        </div>
      </div>
    <Footer />
    </div>;
  }
}